import React, { useState } from 'react';

const StudentCommentary = ({ commentaryData, addComment }) => {
  const [showForm, setShowForm] = useState(false);
  const [title, setTitle] = useState('');
  const [commentary, setCommentary] = useState('');

  const handleAddClick = () => setShowForm(true);
  const handleCancel = () => {
    setShowForm(false);
    setTitle('');
    setCommentary('');
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (title.trim() && commentary.trim()) {
      addComment(title, commentary);
      setShowForm(false);
      setTitle('');
      setCommentary('');
    }
  };

  return (
    <div className="commentary-section">
      <div className="commentary-section-header">Student Commentary</div>
      {!showForm && (
        <button className="add-comment-btn" onClick={handleAddClick}>
          Add Commentary
        </button>
      )}
      {showForm && (
        <form className="add-comment-form" onSubmit={handleSubmit}>
          <div className="add-comment-field">
            <label className="add-comment-label">Title:</label>
            <input
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              className="add-comment-input"
              required
            />
          </div>
          <div className="add-comment-field">
            <label className="add-comment-label">Commentary:</label>
            <textarea
              value={commentary}
              onChange={e => setCommentary(e.target.value)}
              className="add-comment-textarea"
              required
            />
          </div>
          <button type="submit" className="add-comment-submit">Add</button>
          <button type="button" onClick={handleCancel} className="add-comment-cancel">Cancel</button>
        </form>
      )}
      {commentaryData?.comments?.length === 0 && (
        <p className="commentary-empty">No student commentary yet.</p>
      )}
      {commentaryData?.comments?.map((comment, index) => (
        <div key={index} className="commentary-box">
          {comment.Title && <div className="commentary-title">{comment.Title}</div>}
          <div>{comment.Commentary}</div>
        </div>
      ))}
    </div>
  );
};

export default StudentCommentary;
